// This file is auto-generated by scripts/generate-revision.js
// Do not edit manually - changes will be overwritten on next build

export const REVISION = 'd927e4090 (test)';
export const VERSION = '0.16.12';
